export const alertBox = (txt, state = "warning", type = 1) => {
  if(type == 1){
    silverBox({
      title: {
        alertIcon: state,
        customIconClassName: "",
        text: txt,
      },
      cancelButton: {
        bgColor: "",
        borderColor: "",
        className: "w-50 mx-auto ",
        closeOnClick: true,
        loadingAnimation: true,
        onClick: null,
        showButton: true,
        text: "بستن",
        textColor: "",
      },
      direction: "rtl",
    });
  }else if(type == 2){
    silverBox({
      title: {
        alertIcon: state,
        text: txt
      },
      pauseOnHover : false,
      multiple: 3,
      timer: 1600,
      direction: "rtl",
      position: "top-right", 
    });
  }

}
